/**
 * 美食页
 * Created by Yata on 2017/9/21 0001.
 */
export default [{
        path: '/catestore/:shopId',
        component: () => import('../components/cate/MerchantDetails.vue'),
        meta: {
            title: "商户详情"
        }
    },
    {
        path: '/cate/:goodsType/:id',
        component: () => import('../components/cate/discountDetails.vue')
    }
]
